import { useState } from 'react'
import { getMetaMovieTitle, resolveSourceEntry } from './PageMetaMappingPage'
import Translation from '../../Translation/cont/Translation'
import SearchInput from '../../general/SearchInput'

const getCinemaShorts = (pk, movieMappings, providerMoviesProps, cinemas) => {
    const sources = (movieMappings && movieMappings[pk] && movieMappings[pk].source) || []
    const resolved = sources.map(e => resolveSourceEntry(e, providerMoviesProps, cinemas)).filter(Boolean)
    return _.uniq(resolved.map(r => r.cinemaShort))
}

const MergeMovieCard = ({ title, cinemaShorts, mapping, labelId, isKept, onClick }) => {
    const hasProvider = cinemaShorts.length > 0
    const hasTmdb = !!(mapping && mapping.tmdb)
    const hasPreview = !!(mapping && mapping.preview)
    return (
        <div
            className={'meta-mapping-merge-card' + (isKept ? ' meta-mapping-merge-card--kept' : ' meta-mapping-merge-card--source')}
            onClick={onClick}
        >
            <div className="meta-mapping-merge-card-label text-light-uppercase">
                <Translation id={labelId} />
                {isKept && <span className="meta-mapping-merge-card-check">✓</span>}
            </div>
            <div className="meta-mapping-merge-card-title">{title}</div>
            <div className="meta-mapping-merge-card-footer">
                {cinemaShorts.length > 0 && (
                    <div className="meta-mapping-merge-card-cinemas">
                        {cinemaShorts.map(s => (
                            <span key={s} className="tmdb-badge tmdb-badge--cinema text-small-light">{s}</span>
                        ))}
                    </div>
                )}
                <div className="meta-mapping-data-pills">
                    {hasProvider && <span className="meta-mapping-pill meta-mapping-pill--provider text-small-light"><Translation id="source_ks" /></span>}
                    {hasTmdb && <span className="meta-mapping-pill meta-mapping-pill--tmdb text-small-light"><Translation id="tmdb_label" /></span>}
                    {hasPreview && <span className="meta-mapping-pill meta-mapping-pill--preview text-small-light"><Translation id="button_preview" /></span>}
                </div>
            </div>
        </div>
    )
}

const TargetPickerModal = ({
    type,
    movieMappings,
    cinemas,
    providerMoviesProps,
    pmPreviewMovies,
    cliMovies,
    excludePk,
    preselectedTargetPk = null,
    onConfirm,
    onCancel,
}) => {
    const startsAtConfirm = !!preselectedTargetPk && 'merge' === type
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedTargetPk, setSelectedTargetPk] = useState(preselectedTargetPk)
    const [step, setStep] = useState(startsAtConfirm ? 'confirm' : 'pick')
    const [keptPk, setKeptPk] = useState(startsAtConfirm ? preselectedTargetPk : null)

    const allPks = movieMappings ? Object.keys(movieMappings).filter(pk => String(pk) !== String(excludePk)) : []

    const titleByPk = {}
    allPks.forEach(pk => { titleByPk[pk] = getMetaMovieTitle(pk, movieMappings, providerMoviesProps, cinemas, pmPreviewMovies, cliMovies) })

    const filteredPks = allPks
        .filter(pk => !searchQuery || titleByPk[pk].toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => titleByPk[a].localeCompare(titleByPk[b]))

    const sourceTitle = getMetaMovieTitle(excludePk, movieMappings, providerMoviesProps, cinemas, pmPreviewMovies, cliMovies)
    const targetTitle = selectedTargetPk ? titleByPk[selectedTargetPk] : ''

    const excludeShorts = getCinemaShorts(excludePk, movieMappings, providerMoviesProps, cinemas)
    const targetShorts = selectedTargetPk ? getCinemaShorts(selectedTargetPk, movieMappings, providerMoviesProps, cinemas) : []

    const handlePickConfirm = () => {
        if (!selectedTargetPk) return
        if (type === 'merge') {
            setKeptPk(selectedTargetPk)
            setStep('confirm')
        } else {
            onConfirm(selectedTargetPk)
        }
    }

    const handleMergeConfirm = () => {
        const effectiveKeptPk = keptPk || selectedTargetPk
        const keptTitle = effectiveKeptPk === excludePk ? sourceTitle : targetTitle
        if (effectiveKeptPk === excludePk) {
            onConfirm(excludePk, selectedTargetPk, keptTitle)
        } else {
            onConfirm(selectedTargetPk, undefined, keptTitle)
        }
    }

    if (step === 'confirm') {
        const effectiveKeptPk = keptPk || selectedTargetPk
        return (
            <div className="meta-mapping-modal-overlay" onClick={onCancel}>
                <div className="meta-mapping-modal" onClick={e => e.stopPropagation()}>
                    <div className="meta-mapping-modal-head">
                        <h3 className="meta-mapping-modal-title">
                            <Translation id="meta_mapping_merge_with" />
                        </h3>
                        <button className="meta-mapping-modal-close" onClick={onCancel}>✕</button>
                    </div>

                    <div className="meta-mapping-merge-confirm">
                        <MergeMovieCard
                            title={sourceTitle}
                            cinemaShorts={excludeShorts}
                            mapping={movieMappings[excludePk]}
                            labelId={effectiveKeptPk === excludePk ? 'meta_mapping_merge_kept' : 'meta_mapping_merge_into'}
                            isKept={effectiveKeptPk === excludePk}
                            onClick={() => setKeptPk(excludePk)}
                        />
                        <MergeMovieCard
                            title={targetTitle}
                            cinemaShorts={targetShorts}
                            mapping={movieMappings[selectedTargetPk]}
                            labelId={effectiveKeptPk === selectedTargetPk ? 'meta_mapping_merge_kept' : 'meta_mapping_merge_into'}
                            isKept={effectiveKeptPk === selectedTargetPk}
                            onClick={() => setKeptPk(selectedTargetPk)}
                        />
                    </div>

                    <div className="meta-mapping-merge-hint">
                        <p className="text-xsmall-light"><Translation id="meta_mapping_merge_hint_details" /></p>
                        <p className="text-xsmall-light"><Translation id="meta_mapping_merge_hint_performances" /></p>
                    </div>

                    <div className="meta-mapping-modal-footer">
                        <button className="tmdb-link-btn text-small-regular" onClick={() => { setKeptPk(null); setStep('pick') }}>
                            <Translation id="cancel_button" />
                        </button>
                        <button className="tmdb-action-btn text-small-regular" onClick={handleMergeConfirm}>
                            <Translation id="confirm_button" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="meta-mapping-modal-overlay" onClick={onCancel}>
            <div className="meta-mapping-modal" onClick={e => e.stopPropagation()}>
                <div className="meta-mapping-modal-head">
                    <h3 className="meta-mapping-modal-title">
                        <Translation id={type === 'merge' ? 'meta_mapping_merge_with' : 'meta_mapping_move_to'} />
                    </h3>
                    <button className="meta-mapping-modal-close" onClick={onCancel}>✕</button>
                </div>
                <div className="meta-mapping-modal-search">
                    <SearchInput
                        placeholderTransId="social_media_search_movie_placeholder"
                        value={searchQuery}
                        onChange={setSearchQuery}
                        autoFocus
                    />
                </div>
                <ul className="meta-mapping-modal-list">
                    {filteredPks.map(pk => {
                        const hasPreview = !!(movieMappings[pk] && movieMappings[pk].preview)
                        return (
                            <li
                                key={pk}
                                className={'meta-mapping-modal-item' + (selectedTargetPk === pk ? ' selected' : '')}
                                onClick={() => setSelectedTargetPk(pk)}
                            >
                                <div className="meta-mapping-modal-item-info">
                                    <span className="meta-mapping-modal-item-title text-small-regular">{titleByPk[pk]}</span>
                                    {hasPreview && (
                                        <span className="meta-mapping-pill meta-mapping-pill--preview text-small-light">
                                            <Translation id="button_preview" />
                                        </span>
                                    )}
                                </div>
                                <span className="meta-mapping-modal-item-pk text-small-light">{pk}</span>
                            </li>
                        )
                    })}
                    {filteredPks.length === 0 && (
                        <li className="meta-mapping-modal-empty text-small-light"><Translation id="content_no_movies_available" /></li>
                    )}
                </ul>
                <div className="meta-mapping-modal-footer">
                    <button className="tmdb-link-btn text-small-regular" onClick={onCancel}><Translation id="cancel_button" /></button>
                    <button
                        className="tmdb-action-btn text-small-regular"
                        onClick={handlePickConfirm}
                        disabled={!selectedTargetPk}
                    >
                        <Translation id="save_button" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TargetPickerModal
